module.exports = __webpack_public_path__ + "42d815c1ba07fec6291666db9fa05231.pdf";